// // import React from 'react';
// // import { useForm } from 'react-hook-form';
// // import { useMutation, useQueryClient, useQuery } from 'react-query';
// // import { yupResolver } from '@hookform/resolvers/yup';
// // import * as yup from 'yup';
// // import { createCategory, updateCategory, getCategory } from '../../../api/category';
// // import { useParams, useNavigate } from 'react-router-dom';
// // import { toast } from 'react-toastify';

// // const schema = yup.object().shape({
// //   name: yup.string().required('Name is required'),
// //   cover: yup.mixed().required('Cover image is required')
// // });

// // const CategoryForm = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   const queryClient = useQueryClient();
// //   const { register, handleSubmit, setValue, formState: { errors } } = useForm({
// //     resolver: yupResolver(schema)
// //   });

// //   const { data: category } = useQuery(['category', id], () => getCategory(id), {
// //     enabled: !!id,
// //     onSuccess: (data) => {
// //       setValue('name', data.name);
// //       setValue('cover', data.cover);
// //     }
// //   });

// //   const mutation = useMutation(
// //     id ? (data) => updateCategory(id, data) : createCategory,
// //     {
// //       onSuccess: () => {
// //         queryClient.invalidateQueries('categories');
// //         toast.success(`Category ${id ? 'updated' : 'created'} successfully`);
// //         navigate('/dashboard/categories');
// //       },
// //       onError: () => {
// //         toast.error(`Failed to ${id ? 'update' : 'create'} category`);
// //       }
// //     }
// //   );

// //   const onSubmit = (data) => {
// //     const formData = new FormData();
// //     formData.append('name', data.name);
// //     formData.append('cover', data.cover[0]);
// //     mutation.mutate(formData);
// //   };

// //   return (
// //     <form onSubmit={handleSubmit(onSubmit)}>
// //       <div>
// //         <label>Name</label>
// //         <input {...register('name')} />
// //         <p>{errors.name?.message}</p>
// //       </div>
// //       <div>
// //         <label>Cover Image</label>
// //         <input type="file" {...register('cover')} />
// //         <p>{errors.cover?.message}</p>
// //       </div>
// //       <button type="submit">{id ? 'Update' : 'Create'} Category</button>
// //     </form>
// //   );
// // };

// // export default CategoryForm;



// // import React, { useState, useEffect } from 'react';
// // import { useForm } from 'react-hook-form';
// // import { useMutation, useQueryClient, useQuery } from 'react-query';
// // import { yupResolver } from '@hookform/resolvers/yup';
// // import * as yup from 'yup';
// // import { createCategory, updateCategory, getCategoryById } from '../../../api/category';
// // import { useParams, useNavigate } from 'react-router-dom';

// // import {
// //   Box,
// //   useToast,

// //   Button,
// //   FormControl,
// //   FormLabel,
// //   Input,
// //   Image,
// //   VStack,
// //   Spinner,
// //   Text,
// //   FormErrorMessage,
// // } from '@chakra-ui/react';
// // import { UpdateDataWithImg } from '../../../api/apiFactory';

// // // Schema validation using Yup
// // const schema = yup.object().shape({
// //   name: yup.string().required('Name is required'),
// //   cover: yup.mixed().required('Cover image is required'),
// // });

// // const CategoryForm = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   const queryClient = useQueryClient();
// //   const [imagePreview, setImagePreview] = useState(null);
// //   const [initialImage, setInitialImage] = useState(null);
// // const toast = useToast();
// //   const { register, handleSubmit, setValue, formState: { errors } } = useForm({
// //     resolver: yupResolver(schema),
// //   });

// //   const { data: category, isLoading, error } = useQuery(['category', id], () => getCategoryById(id), {
// //     enabled: !!id,
// //     onSuccess: (data) => {
// //       const categoryData = data?.data?.data;
// //       setValue('name', categoryData.name);
// //       setInitialImage(`http://localhost:9000/${categoryData.cover?.path}`);  // Assuming cover.path contains the image URL
// //       setImagePreview(`http://localhost:9000/${categoryData.cover?.path}`);
// //     },
// //   });

// //   const mutation = useMutation(
// //     id ? (data) => updateCategory(id, data) : createCategory,
// //     {
// //       onSuccess: () => {
    
// //         queryClient.invalidateQueries('categories');
// //         navigate('/dashboard/admin/categories');
// //         toast({
// //           title: 'Success',
// //           description: `Category ${id ? 'updated' : 'created'} successfully`,
// //           status: 'success',
// //           duration: 3000,
// //           isClosable: true,
// //         })
// //       },
// //       onError: (error) => {
// //         console.log(error)
// //         const errorMessage = error.response?.data?.message;
// //         const errorsArray = error.response?.data?.errors;
  
// //         if (errorsArray && Array.isArray(errorsArray)) {
// //           // Display all error messages if errors are in an array
// //           errorsArray.forEach((err) => {
// //             toast({
// //               title: 'Error',
// //               description: err.msg,
// //               status: 'error',
// //               duration: 3000,
// //               isClosable: true,
// //             });
// //           });
// //         } else if (errorMessage) {

// //           toast({
// //             title: 'Error',
// //             description: errorMessage,
// //             status: 'error',
// //             duration: 3000,
// //             isClosable: true,
// //           });

// //         }
// //         setImagePreview(initialImage);
// //       }
// //     }
// //   );

// //   const onSubmit = (data) => {
// //     const formData = new FormData();
// //     formData.append('name', data.name);
// //     formData.append('cover', data.cover[0]);
// //     mutation.mutate(formData);
// //   };

// //   const handleImageChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImagePreview(URL.createObjectURL(file));
// //     } else {
// //       setImagePreview(initialImage);
// //     }
// //   };

// //   if (isLoading) {
// //     return (
// //       <Box textAlign="center" py={10} px={6}>
// //         <Spinner size="xl" />
// //       </Box>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <Box textAlign="center" py={10} px={6}>
// //         <Text color="red.500">Error: {error.message}</Text>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box maxW="md" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
// //       <form onSubmit={handleSubmit(onSubmit)}>
// //         <VStack spacing={4}>
// //           <FormControl isInvalid={errors.name}>
// //             <FormLabel htmlFor="name">Name</FormLabel>
// //             <Input id="name" {...register('name')} />
// //             <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
// //           </FormControl>

// //           <FormControl isInvalid={errors.cover}>
// //             <FormLabel htmlFor="cover">Cover Image</FormLabel>
// //             {imagePreview && (
// //               <Image
// //                 src={imagePreview}
// //                 alt="Cover Preview"
// //                 boxSize="150px"
// //                 objectFit="cover"
// //                 mb={4}
// //                 borderRadius="md"
// //               />
// //             )}
// //             <Input
// //               type="file"
// //               id="cover"
// //               {...register('cover')}
// //               onChange={handleImageChange}
// //             />
// //             <FormErrorMessage>{errors.cover?.message}</FormErrorMessage>
// //           </FormControl>

// //           <Button type="submit" colorScheme="blue" isLoading={mutation.isLoading}>
// //             {id ? 'Update' : 'Create'} Category
// //           </Button>
// //         </VStack>
// //       </form>
// //     </Box>
// //   );
// // };

// // export default CategoryForm;




import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { createCategory, updateCategory, getCategoryById } from '../../../api/category';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  useToast,
  Button,
  FormControl,
  FormLabel,
  Input,
  Image,
  VStack,
  Spinner,
  Text,
  FormErrorMessage,
} from '@chakra-ui/react';
import Api from '../../../api/ApiUrl'

// Schema validation using Yup
const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  cover: yup.mixed().required('Cover image is required'),
});

const CategoryForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [imagePreview, setImagePreview] = useState(null);
  const [initialImage, setInitialImage] = useState(null);
  const toast = useToast();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { data: category, isLoading, error } = useQuery(['category', id], () => getCategoryById(id), {
    enabled: !!id,
    onSuccess: (data) => {
      const categoryData = data?.data?.data;
      setValue('name', categoryData.name);
      setInitialImage(`${Api}/${categoryData?.cover?.path}`);
      setImagePreview(`${Api}/${categoryData?.cover?.path}`);
    },
  });

  const mutation = useMutation(id ? (data) => updateCategory(id, data) : createCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('categories');
      navigate('/dashboard/admin/categories');
      toast({
        title: 'Success',
        description: `Category ${id ? 'updated' : 'created'} successfully`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: (error) => {
      console.error(error);
      const errorMessage = error.response?.data?.message;
      const errorsArray = error.response?.data?.errors;

      if (errorsArray && Array.isArray(errorsArray)) {
        errorsArray.forEach((err) => {
          toast({
            title: 'Error',
            description: err.msg,
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        });
      } else if (errorMessage) {
        toast({
          title: 'Error',
          description: errorMessage,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
      setImagePreview(initialImage);
    },
  });

  const onSubmit = (data) => {
    console.log(data)
    const formData = new FormData();
    console.log(data.name)
    formData.append('name', data.name);
    if (data.cover[0]) {
  formData.append('cover', data.cover[0]);
 mutation.mutate(formData);

  return 
    } else {
 mutation.mutate(formData);
 return 
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImagePreview(initialImage);
    }
  };

  if (isLoading) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Text color="red.500">Error: {error.message}</Text>
      </Box>
    );
  }

  return (
    <Box maxW="md" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={4}>
          <FormControl isInvalid={errors.name}>
            <FormLabel htmlFor="name">Name</FormLabel>
            <Input id="name" {...register('name')} />
            <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.cover}>
            <FormLabel htmlFor="cover">Cover Image</FormLabel>
            {/* {imagePreview && (
              <Image
                src={imagePreview}
                alt="Cover Preview"
                boxSize="150px"
                objectFit="cover"
                mb={4}
                borderRadius="md"
              />
            )} */}
            <Input
              type="file"
              id="cover"
              {...register('cover')}
               
              onChange={handleImageChange}
            />
            <FormErrorMessage>{errors.cover?.message}</FormErrorMessage>
          </FormControl>

          <Button type="submit" colorScheme="blue" isLoading={mutation.isLoading}>
            {id ? 'Update' : 'Create'} Category
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default CategoryForm;



// import React from 'react';
// import { useFormik } from 'formik';
// import { categorySchema } from '../../../validations/categories/validationSchema';
// import {
//   Box,
//   Button,
//   FormControl,
//   FormErrorMessage,
//   FormLabel,
//   Input,
// } from '@chakra-ui/react';
// import { useAddCategory, useUpdateCategory } from '../../../hooks/useCategories';
// import { useNavigate, useParams } from 'react-router-dom';

// const CategoryForm = ({ initialValues = { name: '', cover: { name: '', path: '', pathname: '' } } }) => {
//   const { id } = useParams();
//   const isEdit = !!id;
//   const addCategory = useAddCategory();
//   const updateCategory = useUpdateCategory();
//   const history = useNavigate();

//   const formik = useFormik({
//     initialValues,
//     validationSchema: categorySchema,
//     onSubmit: (values, { setSubmitting }) => {
//       if (isEdit) {
//         updateCategory.mutate({ id, category: values }, {
//           onSuccess: () => {
//             history('/categories');
//           },
//           onError: (error) => {
//             if (error.response && error.response.data) {
//               formik.setErrors(error.response.data.errors);
//             }
//           },
//           onSettled: () => {
//             setSubmitting(false);
//           }
//         });
//       } else {
//         addCategory.mutate(values, {
//           onSuccess: () => {
//             history('/categories');
//           },
//           onError: (error) => {
//             if (error.response && error.response.data) {
//               formik.setErrors(error.response.data.errors);
//             }
//           },
//           onSettled: () => {
//             setSubmitting(false);
//           }
//         });
//       }
//     }
//   });

//   return (
//     <Box as="form" onSubmit={formik.handleSubmit}>
//       <FormControl isInvalid={formik.touched.name && formik.errors.name}>
//         <FormLabel htmlFor="name">Category Name</FormLabel>
//         <Input
//           id="name"
//           name="name"
//           type="text"
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           value={formik.values.name}
//         />
//         <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
//       </FormControl>
//       <FormControl isInvalid={formik.touched.cover?.name && formik.errors.cover?.name} mt="4">
//         <FormLabel htmlFor="coverName">Cover Image Name</FormLabel>
//         <Input
//           id="coverName"
//           name="cover.name"
//           type="text"
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           value={formik.values.cover.name}
//         />
//         <FormErrorMessage>{formik.errors.cover?.name}</FormErrorMessage>
//       </FormControl>
//       <FormControl isInvalid={formik.touched.cover?.path && formik.errors.cover?.path} mt="4">
//         <FormLabel htmlFor="coverPath">Cover Image Path</FormLabel>
//         <Input
//           id="coverPath"
//           name="cover.path"
//           type="text"
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           value={formik.values.cover.path}
//         />
//         <FormErrorMessage>{formik.errors.cover?.path}</FormErrorMessage>
//       </FormControl>
//       <FormControl isInvalid={formik.touched.cover?.pathname && formik.errors.cover?.pathname} mt="4">
//         <FormLabel htmlFor="coverPathname">Cover Image Pathname</FormLabel>
//         <Input
//           id="coverPathname"
//           name="cover.pathname"
//           type="text"
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           value={formik.values.cover.pathname}
//         />
//         <FormErrorMessage>{formik.errors.cover?.pathname}</FormErrorMessage>
//       </FormControl>
//       <Button
//         mt="4"
//         colorScheme="teal"
//         isLoading={formik.isSubmitting}
//         type="submit"
//       >
//         {isEdit ? 'Update Category' : 'Add Category'}
//       </Button>
//     </Box>
//   );
// };

// export default CategoryForm;
